document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tabs-header li");
    const tabContents = document.querySelectorAll(".tab-content");

    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            // Récupérer l'ID du tab cible
            const tabId = this.getAttribute("data-tab");

            // Supprimer la classe 'current' de tous les onglets et contenus
            tabs.forEach(t => t.classList.remove("current"));
            tabContents.forEach(content => content.classList.remove("current"));

            // Ajouter la classe 'current' au tab et à son contenu correspondant
            this.classList.add("current");
            document.getElementById(tabId).classList.add("current");
        });
    });
});
